<script setup lang="ts">
  const props = withDefaults(defineProps<{ title?: string; bleed?: boolean }>(), { title: undefined, bleed: false });
</script>

<template>
  <div class="border-t bg-muted">
    <p
      v-if="props.title"
      class="heading-label px-8 pt-3 pb-2">
      {{ props.title }}
    </p>
    <div :class="props.bleed ? undefined : ['px-8 pb-3', !props.title && 'pt-3']">
      <slot />
    </div>
  </div>
</template>
